import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IModalComponent } from '../../models/modal-behaviour.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-attachment-modal',
  templateUrl: './add-attachment-modal.component.html',
  styleUrls: ['./add-attachment-modal.component.scss']
})
export class AddAttachmentModalComponent extends IModalComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<File>();
  fileForm!: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  override handleModalHide(): void {
    this.fileForm.reset();
  }

  handleSubmit(): void {
    this.onSubmit.emit(this.fileForm.value.file[0]);
    this.toggleModal();
  }

  private initForm(): void {
    this.fileForm = this.fb.group({
      file: [null, Validators.required],
    });
  }
}
